import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=6dc22e03&scoped=true&lang=pug&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=6dc22e03&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc22e03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc22e03')) {
      api.createRecord('6dc22e03', component.options)
    } else {
      api.reload('6dc22e03', component.options)
    }
    module.hot.accept("./noticeList.vue?vue&type=template&id=6dc22e03&scoped=true&lang=pug&", function () {
      api.rerender('6dc22e03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notice/noticeList.vue"
export default component.exports